import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
    fontFamily: `${theme.typography.fontFamily} !important`,
    borderRadius: '4px !important',
    backgroundColor: `${theme.palette.labraText.tertiary} !important`,
    maxWidth: theme.spacing(31.875),
    minHeight: theme.spacing(3),
    boxSizing: 'border-box',
    color: theme.palette.tooltipText.main,
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 400,
  },
  footer: {
    display: 'flex',
    justifyContent: 'end',
    gap: theme.spacing(2.5),
    height: theme.spacing(3),
  },
}))
